import { useSocialTrafficContext } from "app/pages/website-analysis/social-overview/socialTraffic/context";
import { Legends as LegendsComponent } from "app/components/React/Legends/Legends";
import styled from "styled-components";

const Container = styled.div`
    padding-bottom: 20px;
`;

export const Legends = () => {
    const { legendItems, setLegendItems } = useSocialTrafficContext();
    const toggleSeries = (clickedItem) => {
        const newLegendItems = legendItems.map((legendItem) => {
            if (legendItem.name === clickedItem.name) {
                legendItem.visible = !clickedItem.visible;
            }
            return legendItem;
        });
        setLegendItems(newLegendItems);
    };
    const legendsProps = { legendItems, toggleSeries };
    const isCompareMode = legendItems.length > 1;
    return isCompareMode ? (
        <Container>
            <LegendsComponent {...legendsProps} />
        </Container>
    ) : null;
};
